let paystackPromise = null;

/**
 * Lazily loads Paystack's Inline JS (only when a payment is actually
 * initiated) and resolves with the global PaystackPop constructor.
 */
export function loadPaystackScript() {
  if (window.PaystackPop) return Promise.resolve(window.PaystackPop);
  if (paystackPromise) return paystackPromise;

  paystackPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://js.paystack.co/v1/inline.js';
    script.async = true;
    script.onload = () => resolve(window.PaystackPop);
    script.onerror = () => {
      paystackPromise = null;
      reject(new Error('Failed to load the payment provider. Check your connection and try again.'));
    };
    document.body.appendChild(script);
  });

  return paystackPromise;
}
